import React, {useState} from "react";
import {Link} from "react-router-dom";
import {useFormik} from "formik";
import * as Yup from "yup";
import {connect} from "react-redux";
import {actions} from "../../../../redux/modules/auth/actions";
import {login} from "../../../../redux/modules/auth/crud";
import {makeValidClasses, makeHasError} from "../../../../utils/formHelpers";

const isProd = process.env.NODE_ENV === 'production'

const initialValues = {
  adminId: isProd ? "" : "justcode",
  adminPasswd: isProd ? "" : "dkdlvhs3gs",
};

function Login(props) {
  const [loading, setLoading] = useState(false);
  const enableLoading = () => setLoading(true);
  const disableLoading = () => setLoading(false);

  const LoginSchema = Yup.object().shape({
    adminId: Yup.string()
      .min(3, "3글자 이상 입력하세요.")
      .max(50, "50글자 미만으로 입력하세요.")
      .required("필수 입력항목입니다."),
    adminPasswd: Yup.string()
      .min(3, "3글자 이상 입력하세요.")
      .max(50, "50글자 미만으로 입력하세요.")
      .required("필수 입력항목입니다."),
  });

  const form = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      enableLoading();
      setTimeout(() => {
        const {adminId, adminPasswd} = values;
        login({adminId, adminPasswd})
          .then(({token}) => {
            disableLoading();
            props.login(token);
          })
          .catch((err) => {
            disableLoading();
            setSubmitting(false);
            setStatus(err.message);
          });
      }, 1000);
    },
  });

  const getValidClasses = makeValidClasses(form);
  const hasError = makeHasError(form);

  return (
    <div id="kt_login_signin_form" className="login-form login-signin">

      {/* begin::Head */}
      <div className="text-center mb-10 mb-lg-20">
        <h3 className="font-size-h1">룰루 판매파트너 로그인</h3>
        <p className="text-muted font-weight-bold">
          아직 계정이 없으신가요 ? 여기서
          <Link className="font-weight-bold ml-2" to="/registration">
            계정을 생성
          </Link>
          하세요.
        </p>
      </div>
      {/* end::Head */}

      {/*begin::Form*/}
      <form
        onSubmit={form.handleSubmit}
        className="form fv-plugins-bootstrap fv-plugins-framework"
      >

        {form.status && (
          <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
            <div className="alert-text font-weight-bold">{form.status}</div>
          </div>
        )}

        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="아이디"
            type="text"
            name="adminId"
            className={`form-control form-control-solid h-auto py-5 px-6 ${getValidClasses("adminId")}`}
            {...form.getFieldProps("adminId")}
          />
          {hasError('adminId') ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{form.errors.adminId}</div>
            </div>
          ) : null}
        </div>

        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="비밀번호"
            type="password"
            name="adminPasswd"
            className={`form-control form-control-solid h-auto py-5 px-6 ${getValidClasses("adminPasswd")}`}
            {...form.getFieldProps("adminPasswd")}
          />
          {hasError('adminPasswd') ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{form.errors.adminPasswd}</div>
            </div>
          ) : null}
        </div>

        <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
          <div className="mt-5 mb-3 text-center flex-grow-1">
            <Link to="/forgot-id">아이디 찾기</Link>
            <span className="align-self-center font-size-xs text-dark-50">{" | "}</span>
            <Link to="/forgot-password">비밀번호 찾기</Link>
          </div>
          <button
            id="kt_login_signin_submit"
            className={`btn btn-primary btn-block font-weight-bold px-9 py-4 my-3`}
            type="submit"
            disabled={form.isSubmitting}
          >
            <span>로그인</span>
            {loading && <span className="ml-3 spinner spinner-white"/>}
          </button>
        </div>
      </form>
      {/*end::Form*/}
    </div>
  );
}

export default connect(null, actions)(Login);
